import { Component, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from "@angular/router";
import { ComponentPageTitle } from '../../page-title/page-title.component';
import { AppServiceService } from '../../services/app-service.service';
import { MatPaginator, MatTableDataSource, MatDialog, MatDialogRef, MAT_DIALOG_DATA, MatSnackBar, PageEvent } from '@angular/material';
import { CreatecampanaComponent } from 'src/app/home/createcampana/createcampana.component';
import { ModifyCampanaComponent } from 'src/app/home/modify-campana/modify-campana.component';
import { CreateScheduleComponent } from 'src/app/home/create-schedule/create-schedule.component';
import { CreateAlarmaComponent } from 'src/app/home/create-alarma/create-alarma.component';
import { CreateCriterioComponent } from 'src/app/home/create-criterio/create-criterio.component';
import { GatewayService } from 'src/app/gateway.service';
import { Subscription } from 'rxjs/Subscription';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BusquedaService } from '../busqueda.service';
import { CreateService } from '../createservice';
import { CreateCicloComponent } from 'src/app/home/create-ciclo/create-ciclo.component';
import { FiltroPaisService } from '../filtro-pais.service';
import { LocalSaveService } from 'src/app/services/local-save-service.service';
import * as XLSX from 'xlsx';
import { saveAs } from 'file-saver';
import { NgxSpinnerService } from 'ngx-spinner';
import { ConfirmacionComponent } from '../confirmacion/confirmacion.component';
import { PasswordnewComponent } from 'src/app/login/passwordnew/passwordnew.component';
import { DlgCampanaComponent } from 'src/app/home/autorizar-campana/dlg-campana/dlg-campana.component';
import { VerImgComponent } from 'src/app/home/equipo-recolectado/ver-img/ver-img.component'

@Component({
  selector: 'app-equipo-recolectado',
  templateUrl: './equipo-recolectado.component.html',
  styleUrls: ['./equipo-recolectado.component.scss']
})
export class EquipoRecolectadoComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  // campanaColumns: string[] = ['IMAGEN', 'CODPRODUCTO', 'SERIE', 'MAC', 'NUMSERVICIO', 'ACCION'];
  campanaColumns: string[] = ['IMAGEN', 'CODPRODUCTO', 'SERIE', 'MAC', 'NUMSERVICIO', 'CONTRATA'];
  dataSource = new MatTableDataSource<any>([]);
  FILTER: string = '';
  resultsLength: number = 0;
  pageSize = 10;
  private subscription: Subscription;
  private subscriptioncreate: Subscription;
  private subscriptionpais: Subscription;
  idpais;
  pageEvent: PageEvent;
  public actpage: number = 0;

  constructor(
    private router: Router,
    private snackbar: MatSnackBar,
    private gateway: GatewayService,
    public pageTitle: ComponentPageTitle,
    public _appservice: AppServiceService,
    public _busqueda: BusquedaService,
    public _create: CreateService,
    private dialog: MatDialog,
    public _filtroPais: FiltroPaisService,
    private localSave: LocalSaveService,
    private spinner: NgxSpinnerService
  ) { }

  @ViewChild('campanapaginator') campanapaginator: MatPaginator;

  ngOnInit() {
    const user = this.localSave.get('usuarioPGV');
    if (!user || (user.idrol != 21 && user.idrol != 16 && user.idrol != 1)) {
      this.router.navigate(['/home']);
    } else if (user.idrol == 1) {
      this.campanaColumns = ['IMAGEN', 'DESC', 'CODPRODUCTO', 'SERIE', 'MAC', 'NUMSERVICIO', 'FOTOS'];
    } else if (user.idrol == 16) {
      this.campanaColumns = ['IMAGEN', 'DESC', 'CODPRODUCTO', 'SERIE', 'MAC', 'NUMSERVICIO', 'CONTRATA', 'FOTOS', 'ESTADO'];
    } else if (user.idrol == 21) {
      this.campanaColumns = ['IMAGEN', 'DESC', 'CODPRODUCTO', 'SERIE', 'MAC', 'NUMSERVICIO', 'CONTRATA', 'FOTOS', 'ESTADO'];
    }

    this.idpais = this.localSave.get('pais');
    this.get(0);
    this.pageTitle.title = 'Equipo Recolectado';
    // this.loadUsuarios();
    this.subscription = this._busqueda.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        this.filtrarcampana(res.filtro);
      });
    this.subscriptionpais = this._filtroPais.notifyObservable$.pipe(takeUntil(this.destroy$)).subscribe(
      res => {
        // console.log(res);
        this.idpais = res.IDPAIS;
        this.get(0);
      }
    );
  }

  openImageDialog(element: string, index=0): void {
    element['currentIndex'] = index;
    this.dialog.open(VerImgComponent, {
      // data: { element.url },
      data: element,
      // width: '80%',
      width: 'auto',
      // height: '90%',
    });
  }

  // ============== FILTRO ==============
  selected = 2
  filter = '';
  public keyDownFunction(event) {
    if (event.keyCode == 13) {
      this.filtrogeneral();
    } else if (event.keyCode == 8 && this.filter == '') {
      this.filtrogeneral();
    }
  }
  public filtrogeneral() {
    this._busqueda.notificarBusqueda({ filtro: this.filter });
  }

  ngAfterViewInit() {
    // console.log(this.localSave.get('nuevoUserPass'))

    // if (this.localSave.get('nuevoUserPass') == 0) {
    //   setTimeout(() => {
    //     this.openPassword();
    //   })

    // }
  }

  cambiarEstado(element: any, idestado: any, estado: any) {
    const dialogRef = this.dialog.open(ConfirmacionComponent, {
      disableClose: true,
      width: '450px',
      data: { operacion: 'setestadoequipore', id: { ID: this.localSave.get('usuarioPGV').IDU, IDESTADO: idestado, ...element }, msj: `cambiar el estado a "${estado}"` }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result.resp) {
        this.gateway.get(result.operacion, result).then((result: any) => {
          this.get(this.actpage);
          // this.spinner.hide()
          // this.campanapaginator.firstPage();
          // this.get(0);
        });
      }
    });
  }

  get(page) {
    const params = {
      NUM_PAGINA: page,
      FILTRO: this.FILTER,
      NUM_ELEMENTOS: this.pageSize,
      IDPAIS: this.idpais,
      IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU,
      IDPADRE: this.localSave.get('usuarioPGV').IDU,
      IDAREA: this.localSave.get('usuarioPGV').IDAREA,
      ESDISTRIBUIDOR: this.localSave.get('usuarioPGV').esDistribuidor
    };
    // console.log(params);
    this.spinner.show();
    this.gateway.get('getequipore', params).then((result: any) => {
      const equipos = result.rows;
      this.dataSource = new MatTableDataSource(equipos);
      this.gateway.get('getcontequipore', params).then((result: any) => {
        //console.log(result.rows);
        this.resultsLength = result.rows[0].total;
        this.spinner.hide();
      });
    }
    ).catch(function (e) {
      this.spinner.show();
    });
  }

  cambioElementos(event?: PageEvent) {
		this.actpage = event.pageIndex;
		this.get(event.pageIndex);
	}

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    // this.subscription.unsubscribe();
    // this.subscriptioncreate.unsubscribe();
    // this.subscriptionpais.unsubscribe();
  }

  filtrarcampana(data) {
    this.FILTER = data;
    this.get(0);
  }

  //  ====================================================================================== 
  //  ====================================================================================== 
  //  ====================================================================================== 

  exportar(campana) {
    this.spinner.show();
    this.gateway.get('exportarlistacount', { IDCAMPANA: campana.idcampana }).then(
      (data: any) => {
        if (data.rows[0].cantidad > 0) {
          this.prepararinformacion(campana, data.rows[0].cantidad, 0, null);
        } else {
          this.snackbar.open('No hay clientes para esta campaña.', 'Cerrar', { duration: 3000, });
          this.spinner.hide();
        }
      }
    );
  }

  prepararinformacion(campana, count, index, data) {
    this.gateway.get('exportarlistalote', { IDCAMPANA: campana.idcampana, LIMIT: 100, OFFSET: index }).then(
      (result: any) => {
        if (data) {
          data = data.concat(result.rows)
        } else {
          data = result.rows;
        }
        let control = index + 100;
        if (control <= count) {
          this.prepararinformacion(campana, count, control, data);
        } else {
          this.descargarexcel(data, campana);
        }
      }
    );
  }

  descargarexcel(ctr, campana) {
    const fileName = 'Campana' + campana.nombre + '-' + Date.now();
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(ctr);
    XLSX.utils.book_append_sheet(wb, ws);

    const wbout = XLSX.write(wb, { bookType: "xlsx", bookSST: false, type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), fileName + ".xlsx");
    this.spinner.hide();
  }

  public async openPassword() {
    const agente = this.localSave.get('usuarioPGV');
    let dialogRef = await this.dialog.open(PasswordnewComponent, {
      width: '450px',
      disableClose: true,
      data: { title: 'Cambio de contraseña', agente: { idagente: agente.IDU } }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  //----------------ASIGNA MASIVO------------------

  asignaMasivo() {
    document.getElementById("uploadfileasigna").click();
  }

  onFileChangeAsigna(evt: any) {
    let LISTA = [];

    this.spinner.show();

    let uploadname = evt.target.value.split('\\')[evt.target.value.split('\\').length - 1];

    // console.log(uploadname);

    /*    this.openclose=false;*/
    /* wire up file reader */
    const target: DataTransfer = <DataTransfer>(evt.target);
    if (target.files.length !== 1) throw new Error('Cannot use multiple files');
    const reader: FileReader = new FileReader();
    reader.onload = (e: any) => {
      /* read workbook */
      const bstr: string = e.target.result;
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });

      /* grab first sheet */
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      /* save data */
      const dataexcel: any = XLSX.utils.sheet_to_json(ws, { header: 1 });
      (<HTMLInputElement>document.getElementById('uploadfileasigna')).value = null;
      // console.log(dataexcel);
      let csv = [];
      const flag = dataexcel[0];
      const bandera: number = 0;

      //validar columnas

      if (flag[0] === 'USUARIO' && flag[1] === 'CAMPAÑA' && flag[2] === 'CONTACTO' && flag[3] === 'EFECTIVIDAD'
        && flag[4] === 'CONVERSION' && flag[5] === 'TMO(SEG)' && flag[6] === 'LLAMADAS' && flag[7] === 'CONTACTOS EFECTIVOS') {
        dataexcel.forEach((value) => {
          if (value[0] != 'USUARIO' && value[0] != '' && value[0] != undefined
            && value[1] != 'CAMPAÑA' && value[1] != '' && value[1] != undefined
            && value[2] != 'CONTACTO' && value[2] != '' && value[2] != undefined
            && value[3] != 'EFECTIVIDAD' && value[3] != '' && value[3] != undefined
            && value[4] != 'CONVERSION' && value[4] != '' && value[4] != undefined
            && value[5] != 'TMO(SEG)' && value[5] != '' && value[5] != undefined
            && value[6] != 'LLAMADAS' && value[6] != '' && value[6] != undefined
            && value[7] != 'CONTACTOS EFECTIVOS' && value[7] != '' && value[7] != undefined) {
            LISTA.push({
              USUARIO: value[0], CAMPANA: value[1], CONTACTO: value[2], EFECTIVIDAD: value[3]
              , CONVERSION: value[4], TMO: value[5], LLAMADAS: value[6], CONTACTOS: value[7]
            });
          }
        });
        this.loadlistxlsAsigna(LISTA, 0);
      } else {
        this.snackbar.open('Formato de archivo no válido, porfavor intente con otro archivo.', 'CERRAR', { duration: 6000 });
        this.spinner.hide();
      }
    };
    reader.readAsBinaryString(target.files[0]);
  }

  loadlistxlsAsigna(LISTA, cantidad) {
    this.spinner.show();
    let auxarr = [];
    auxarr = LISTA.slice(cantidad, cantidad + 300);
    this.gateway.save('asignamasivaagentes', { IDCAMPANA: 10, LISTA: auxarr, IDDISTRIBUIDOR: this.localSave.get('usuarioPGV').IDU, IDPADRE: this.localSave.get('usuarioPGV').IDU, IDAREA: this.localSave.get('usuarioPGV').IDAREA }).then(
      res => {
        const resultado: any = res;
        if ((cantidad + 300) < LISTA.length) {
          this.loadlistxlsAsigna(LISTA, cantidad + 300);
        } else {
          this.spinner.hide();
          this.snackbar.open('Campañas asignadas con éxito: ' + resultado.agregados + ', campañas no asignadas: ' + resultado.noagregados, 'Cerrar', { duration: 5000, });
          this.get(this.actpage);
        }
      },
      err => {
        this.spinner.hide();
        this.snackbar.open('Los agentes no han sido asignados, intente nuevamente.', 'Cerrar', { duration: 5000, });
        // console.log(err);
      }
    );
  }
}

export interface Campana {
  ID_EJE: number,
  ID_CAMPANA: number,
  NOMBRE: string,
  NOMBREEJE: string,
  ESTADO: number,
  MEDIO: string,
  FECHAINICIAL: string,
  FECHAFINAL: string,
  SCRIPT: string,
  SCRIPTURL: string
}
